// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__SL-Ln","select":"Header_select__340Fu","clinic":"Header_clinic__2HJdB"};